// English translations for product pages (mirrors products.js keys)
export const PRODUCTS_EN = {
    "portail-aluminium": {
        category: "Gates",
        title: "Bespoke aluminium gate",
        seoTitle: "Bespoke aluminium gate | Installation around Geneva",
        seoDescription: "Bespoke aluminium gate: contemporary, durable and maintenance-free. Installation around Geneva, Pays de Gex and Haute-Savoie by Portail du Léman.",
        intro: "The aluminium gate is an ideal solution for an elegant, durable and low-maintenance entrance. Light, sturdy and fully customisable, it fits both contemporary homes and more classic properties.",
        bullets: [
            { t: "Maintenance-free", d: "Aluminium does not rust and keeps its finish for many years." },
            { t: "Bespoke", d: "Dimensions, colours, patterns and infill tailored to your entrance." },
            { t: "Contemporary design", d: "Solid, perforated or mixed lines for a perfect integration." },
            { t: "Motorisable", d: "Compatible with all modern motorization systems — sliding or swing." },
        ],
    },
    "portail-coulissant": {
        category: "Gates",
        title: "Sliding gate for property entrance",
        seoTitle: "Bespoke sliding gate | Installation and motorization",
        seoDescription: "Aluminium sliding gate, motorised or self-supporting. Ideal for sloped ground or narrow entrances. Installation around Lake Geneva.",
        intro: "The sliding gate is ideal when interior clearance is limited or the ground is sloped. Available with ground rail or self-supporting.",
        bullets: [
            { t: "Aluminium or steel", d: "Choose the material to fit your budget and desired aesthetics." },
            { t: "Motorised", d: "Comfortable opening with remote, keypad or intercom." },
            { t: "Ground rail or cantilever", d: "Suited to narrow entrances or sloped sites." },
            { t: "Enhanced safety", d: "Photocells and end-of-travel sensors included." },
        ],
    },
    "portail-battant": {
        category: "Gates",
        title: "Swing gate — classic or contemporary",
        seoTitle: "Bespoke swing gate | Installation around Geneva",
        seoDescription: "Swing gate with 1 or 2 leaves, manual or motorised, wrought iron or contemporary aluminium. Installation around Geneva, Pays de Gex and Haute-Savoie.",
        intro: "The swing gate remains the classic choice for entrances with enough clearance for the swing. Manual or motorised, with 1 or 2 leaves, in contemporary aluminium or wrought iron.",
        bullets: [
            { t: "1 or 2 leaves", d: "Configuration adapted to the width of your entrance." },
            { t: "Motorization available", d: "Articulated arms or rams depending on the configuration." },
            { t: "Wrought iron", d: "Bespoke patterns, copper or gold finishes for a premium look." },
            { t: "Replacement", d: "Fitted on existing or new pillars." },
        ],
    },
    "clotures": {
        category: "Fences",
        title: "Fences to secure and enhance your property",
        seoTitle: "Bespoke fences in Geneva, Pays de Gex & Haute-Savoie",
        seoDescription: "Aluminium, rigid, decorative or opaque fences. Bespoke installation around Geneva and the Lake Geneva basin.",
        intro: "A fence isn't just about marking a boundary. It secures, protects privacy and adds character to your property. Portail du Léman designs fences that suit your setting, with a refined and durable finish.",
        bullets: [
            { t: "Aluminium fence", d: "Modern design, maintenance-free, powder-coated finish." },
            { t: "Rigid fence", d: "Welded panels, highly durable, effective security." },
            { t: "Decorative fence", d: "Perforated patterns, premium finishes to enhance the entrance." },
            { t: "Opaque fence", d: "Solid slats for total privacy." },
        ],
    },
    "brise-vue": {
        category: "Privacy screens",
        title: "Bespoke privacy screens and claustras",
        seoTitle: "Bespoke privacy screens | Claustras and decorative panels",
        seoDescription: "Aluminium privacy screens, claustras and solid panels for gardens, terraces and balconies. Bespoke around Lake Geneva.",
        intro: "Privacy screens protect your intimacy while enhancing your outdoor spaces. We design bespoke solutions for gardens, terraces, balconies, entrances and commercial spaces.",
        bullets: [
            { t: "Aluminium privacy screen", d: "Horizontal or vertical slats with elegant finishes." },
            { t: "Designer claustra", d: "Laser-cut perforated patterns for a strong visual signature." },
            { t: "Solid panels", d: "Completely opaque for terraces and patios." },
            { t: "Bespoke", d: "Tailored to your site, exposure and style." },
        ],
    },
    "motorisation-portail": {
        category: "Motorization",
        title: "Gate motorization and access control",
        seoTitle: "Gate motorization | Sliding, swing, keypad, intercom",
        seoDescription: "Sliding or swing gate motorization, remotes, keypads, intercoms, video intercoms and access-control systems. Installation and after-sales around Lake Geneva.",
        intro: "We install motorization systems tailored to your gate and its expected use. A properly chosen motorization brings comfort, security and durability to your installation.",
        bullets: [
            { t: "Sliding gate", d: "Silent, durable rack-and-pinion motors." },
            { t: "Swing gate", d: "Articulated arms or rams for smooth opening." },
            { t: "Keypad & remotes", d: "Simple, multi-user access and temporary codes." },
            { t: "Intercom & video intercom", d: "Wired or wireless, integrated with your setup." },
        ],
    },
};

export const PORTAILS_OVERVIEW_EN = {
    title: "Bespoke gates for homes, villas and businesses",
    seoTitle: "Bespoke gates in Geneva, Pays de Gex & Haute-Savoie",
    seoDescription: "Aluminium, sliding, swing or motorised gates. Bespoke supply and installation around Geneva, Pays de Gex and Haute-Savoie.",
    intro: "We design, supply and install bespoke gates tailored to your entrance, your site and the style of your property. Whether it's a sliding, swing, manual or motorised gate, we advise you on the best technical and aesthetic solution.",
};
